import toast from 'toasted-notes';

const showNotification = params => {
  toast.notify(params.message, { ...params, position: 'bottom-right' });
  //notification.open({ ...params, placement: 'bottomRight' });
};

export default showNotification;
